import styled from "@emotion/styled";
import { oneOf, oneOfType, shape, string } from "prop-types";
import React from "react";

import ImageComponent, { ImageDataType } from "../../ImageComponent";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
`;

const StyledImage = styled(ImageComponent)`
  max-height: 100px;
  max-width: 200px;
  img {
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }
`;

const BasicImage = styled.img`
  width: 200px;
`;

function AwardLogo({ logo, ...props }) {
  return (
    <Wrapper {...props}>
      {logo.data !== null ? (
        <StyledImage data={logo.data} />
      ) : (
        <BasicImage src={logo.url} alt={logo.alt} title={logo.title} />
      )}
    </Wrapper>
  );
}

export const awardLogo = {
  logo: shape({
    url: string,
    title: string,
    alt: string,
    data: oneOfType([oneOf([null]), shape(ImageDataType)]),
  }),
};

AwardLogo.propTypes = {
  ...awardLogo,
};

AwardLogo.defaultProps = {};

export default AwardLogo;
